module.exports = __webpack_public_path__ + "static/img/invest-TMT5.dc7fcaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT5.jpg
// module id = csGP
// module chunks = 0